/**
 * Created by vwiny on 9/5/2018.
 */
import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  NgZone,
  ViewChild,
  ElementRef, ViewChildren, QueryList, Input, ViewContainerRef, ChangeDetectorRef, OnDestroy, AfterViewInit,
} from '@angular/core';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMBannerSearchService } from './lm-banner-search.service';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMContextService } from '@services/lm-context.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { SohoBusyIndicatorDirective } from 'ids-enterprise-ng';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMHtmlUrlDocComponent } from '@html/lm-html-url-doc.component';
import { LMGlobalPersonalizationService } from '@states/services/lm-global-personalization.service';
import { LMBannerMenuService } from './lm-banner-menu.service';
import { LMRouteComponentService } from '@services/lm-route-component.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { Subject, SubscriptionLike as ISubscription } from 'rxjs';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { debounceTime, takeUntil } from 'rxjs/operators';
import { AppConstants } from '@app/utils';

@Component({
  selector: 'lm-banner-search',
  templateUrl: './lm-banner-search.component.html',
  styleUrls: [ 'lm-banner-search.component.scss' ],
})
export class LMBannerSearchComponent implements AfterViewInit, OnInit, OnDestroy {
  @Input() searchString: string;
  @Input() menuSpecsByWebApp: Array<any>; // todo type me!!
  @Input() dataSearchResults: Array<LMBannerSearchResult>;
  @Input() reportSearchResults: Array<LMBannerSearchResult>;

  // @Input() menuSearchResultsByWebApp: LMBannerSearchResults;
  private _menuSearchResultsByWebApp: LMBannerSearchResults;
  @Input() set menuSearchResultsByWebApp(menuSearchResultsByWebApp: LMBannerSearchResults) {
    this._menuSearchResultsByWebApp = menuSearchResultsByWebApp;

    // todo ben, pwpatton, khollenbech, is there more efficient way to build the webAppSpecsWithSearchResults
    //   when the menuSearchResultsByWebApp changes?
    this.webAppSpecsWithSearchResults = this.lmBannerSearchService.buildWebAppSpecsFromSearchResults(
      this.lmContextService.getAccessibleWebApps(), menuSearchResultsByWebApp, this.lmContextService.getWebApp());
  }
  get menuSearchResultsByWebApp(): LMBannerSearchResults {
    return this._menuSearchResultsByWebApp;
  }

  @Output() menuSearched: EventEmitter<any> = new EventEmitter<any>();
  @Output() menuSearchCleared: EventEmitter<any> = new EventEmitter<any>();

  @ViewChildren('searchMenuHeader') private _searchMenuHeaders: QueryList<ElementRef>;
  @ViewChild(SohoBusyIndicatorDirective, { static: true }) busyIndicator: SohoBusyIndicatorDirective;
  @ViewChild('menuFormDialog', { read: ViewContainerRef, static: true }) placeholder: ViewContainerRef;
  @ViewChild('searchField') searchField: ViewContainerRef;

  public accessibility = {
    announcement: ''
  };

  public webAppSpecsWithSearchResults: LMWebAppSpec[];
  public searchMode: boolean;
  // menuSearchField: LMToolbarSearchField;
  public model = { searchFieldValue: '' };
  public reportTitle: string;
  public dataTitle: string;
  public bannerSearchInfo: LMBannerSearchInfo;
  private subscriptionArray: Array<ISubscription> = []; // todo: type me!
  private menuItemClicked$ = new Subject<any>();
  public searchFieldText$ = new Subject<string>();
  private destroyer$ = new Subject<void>();
  public testVersion1: boolean;

  constructor(
    private routeComponent: LMRouteComponentService,
    private changeDetectorRef: ChangeDetectorRef,
    private lmSpecService: LMSpecService,
    private lmLoggerService: LMLoggerService,
    private lmBannerSearchService: LMBannerSearchService,
    private lmErrorUtilService: LMErrorUtilService,
    private lmContextService: LMContextService,
    private lmBusyIndicatorService: LMBusyIndicatorService,
    private lmUrlUtilService: LMUrlUtilService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmBannerMenuService: LMBannerMenuService,
    private lmGlobalUtilService: LMGlobalUtilService,
    private elementRef: ElementRef,
    private zone: NgZone,
    private lmContextUtilService: LMContextUtilService,
  ) {
    this.searchFieldText$.pipe(
      takeUntil(this.destroyer$),
      debounceTime(1000))
      .subscribe(value => {
        this.fireMenuSearchEvent(event);
      });
  }

  ngOnInit() {
    this.testVersion1 = this.lmContextService.testVersion() === AppConstants.TESTVERSION_V1;
    this.lmLoggerService.trace('@BannerNavComponent -> ngOnInit');
    this.searchMode = false;
    this.model.searchFieldValue = this.searchString;
    this.bannerSearchInfo = this.lmBannerSearchService.getBannerSearchInfo(this.model.searchFieldValue);
    this.setHeaderTitles();
    this.handleFocus();
    this.processAccessibility();
  }

  ngAfterViewInit() {

    /**
     * LMCLIENT-37027
     * Trigger keyup event after DOM is finished loading
     * This will cause the "x" clear button to display in the search input without user interaction
     * The normal functionality for the search control only shows the clear button after a key event
     * Whereas in this use case we need it to show after initial load because the search has been pre-populated
     * And the search button closes the search overlay when clicked.
     */
    this.triggerKeyUpEventOnSearch();
  }

  ngOnDestroy() {
    this.subscriptionArray.forEach(subscription => subscription.unsubscribe());
    this.destroyer$.next();
    this.destroyer$.complete();
  }

  get searchMenuHeaders(): QueryList<ElementRef> {
    return this._searchMenuHeaders;
  }

  get limitSearch(): boolean {
    return this.bannerSearchInfo.limitSearch;
  }

  onMenuSearched(event: Event) {
    this.menuSearched.emit(event);
  }

  onMenuSearchCleared(event: Event) {
    this.menuSearchCleared.emit(event);
  }

  fireClearSearchEvent(event) {
    this.searchMode = false;
    this.menuSearchCleared.emit(event);
    this.hideBusyIndicator();
  }

  autoSearchMenu(searchValue: string) {
    this.searchFieldText$.next(searchValue);
  }

  handleFocus() {
    // This needs to be in a timeout to ensure that the search field is set to focus
    this.zone.runOutsideAngular(() => {
      setTimeout(() => {
        const nativeElement = this.elementRef.nativeElement;
        nativeElement.querySelectorAll('input')[0].focus();
        return;
      }, 2);
    });
  }

  fireMenuSearchEvent(event: Event) {
    this.showBusyIndicator();

    this.menuSearchResultsByWebApp = {};
    this.dataSearchResults = [];
    this.reportSearchResults = [];

    this.bannerSearchInfo = this.lmBannerSearchService.getBannerSearchInfo(this.model.searchFieldValue);

    // this.changeDetectorRef.markForCheck();

    if (!this.model.searchFieldValue) {
      // if value is blank then fire clearSearchEvent event
      this.fireClearSearchEvent(event);
    } else {
      this.bannerSearch();
    }
  }

  private setHeaderTitles() {
    this.reportTitle = Soho.Locale.translate('SearchReportsTitle');
    this.reportTitle = this.reportSearchResults.length > 0 ? this.reportTitle + ' (' + this.reportSearchResults.length + ')' : this.reportTitle;

    this.dataTitle = Soho.Locale.translate('SearchDataTitle');
    this.dataTitle = this.dataSearchResults.length > 0 ? this.dataTitle + ' (' + this.dataSearchResults.length + ')' : this.dataTitle;
  }

  private bannerSearch() {
    const menuSearchUrl = this.lmBannerSearchService.getMenuSearchUrl(this.model.searchFieldValue);

    this.accessibility.announcement = '';

    // this.subscriptionArray.push(); // don't need to push into a subscription array as this observable will completed internally with each call.
    this.lmSpecService.getRedirectUrl(menuSearchUrl).subscribe(response => {
      const dataMenus = response.dataModules;
      const reports = response.reports;

      this.menuSearchResultsByWebApp = this.lmBannerSearchService.matchMultiMenus(this.menuSpecsByWebApp, this.model.searchFieldValue, this.bannerSearchInfo);
      // const searchResultsByWebApp = this.menuSearchResultsByWebApp;
      // const accessibleWebApps = this.lmContextService.getAccessibleWebApps();
      // this.webAppSpecsWithSearchResults = this.lmBannerSearchService.buildWebAppSpecsFromSearchResults(accessibleWebApps, searchResultsByWebApp);
      this.dataSearchResults = this.lmBannerSearchService.matchData(dataMenus);
      this.reportSearchResults = this.lmBannerSearchService.matchReports(reports);

      this.searchMode = true;

      const event: LMBannerSearchEvent = {
        searchString:              this.model.searchFieldValue,
        menuSpecsByWebApp:         this.menuSpecsByWebApp,
        menuSearchResultsByWebApp: this.menuSearchResultsByWebApp,
        dataSearchResults:         this.dataSearchResults,
        reportSearchResults:       this.reportSearchResults,
        toggleMenu:                Object.keys(this.menuSearchResultsByWebApp).length > 0 ? 'Applications' : this.reportSearchResults.length > 0 ? 'Reports' : 'Data'
      };
      this.setHeaderTitles();

      this.menuSearched.emit(event);

      this.hideBusyIndicator();
    },
    error => {
      this._handleError(error);
    },
    () => {
      this.processAccessibility();
    });
  }

  showBusyIndicator() {
    this.lmBusyIndicatorService.showBusyIndicator(this.busyIndicator);
  }

  hideBusyIndicator() {
    this.lmBusyIndicatorService.hideBusyIndicator(this.busyIndicator);
  }

  openSearchMenuItem($event: any) {
    const anchor: any = $event.currentTarget;
    const menuUrl = anchor.getAttribute('searchMenuUrl');

    const routeComponent: LMRouteComponentService = this.routeComponent;
    this.subscriptionArray.push(this.lmSpecService.getBannerSpec(menuUrl).subscribe(
      response => {
        if (response.dialogUrl) {
          const personalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
          if (this.lmContextService.is3_5Content(personalization.appDisplay)) {
            const comp: LMHtmlUrlDocComponent = routeComponent.getHtmlUrlDocComponent();
            comp.runActionFormIn3_5(response.dialogUrl);
          } else {
            this.lmBannerMenuService.requestActionFromPageMenu(response.dialogUrl, response.resourceId, this.placeholder);
          }
        } else if (response.redirectUrl) {
          this.lmContextService.setClearNextPageState(true);
          const url = response.redirectUrl;
          const noDefaultPortUrl = this.lmUrlUtilService.stripDefaultPort(url);
          const host = this.lmContextUtilService.getLocation(noDefaultPortUrl).host;
          if (response.external) {
            this.lmUrlUtilService.openExternalUrl(response.redirectUrl);
          } else if (response.embedded) {
            if ((url.length > 0 && host !== window.location.host) || (response.redirectUrl.indexOf('.html') >= 0)) {
              const isHtmlFragment = response.redirectUrl.indexOf('standalone=true') < 0;
              const webapp = this.lmContextService.getContext().webApp;
              const dataArea = this.lmContextService.getContext().urlPdlOrDa;
              const autoLoadUrl = dataArea + '/' + webapp + '/menu/url?autoLoadUrl=' + encodeURIComponent(response.redirectUrl) + (isHtmlFragment ? '&isHtmlFragment=true' : '');
              this.lmGlobalUtilService.navigateByUrl(autoLoadUrl);
            } else {
              this.lmGlobalUtilService.navigateByUrl(response.redirectUrl);
            }
          } else {
            if ((url.length > 0 && host !== window.location.host) || (response.redirectUrl.indexOf('.html') >= 0)) {
              window.location.href = response.redirectUrl;
            } else {
              this.lmGlobalUtilService.navigateByUrl(response.redirectUrl);
            }
          }
        }
      },
      error => {
        this._handleError(error);
      }));
  }

  public onMenuItemClicked(menuItem: any) {
    this.menuItemClicked$.next(menuItem);
  }

  // public getMenuItemId(menuItem: any) {
  //   if (menuItem.parentMenus && menuItem.parentMenus.indexOf('/') > -1) {
  //     let parentLabelArray = menuItem.parentMenus.split('/');
  //     let lastParent = parentLabelArray[parentLabelArray.length - 2];
  //     lastParent = lastParent.replace(/\s/g, '');
  //     return 'appmenu_' + lastParent + '_prd_' + menuItem.id;
  //   }
  //   return 'appmenu_' + menuItem.id;
  // }

  public openSearchItemLink($event: any) {
    const anchor: any = $event.currentTarget;
    const menuUrl = anchor.getAttribute('searchMenuUrl');
    const resourceId = anchor.getAttribute('resourceId');

    const actionParam = this.lmUrlUtilService.getUrlParam(menuUrl, 'action');
    if (actionParam) {
      const personalization = this.lmGlobalPersonalizationService.getGlobalPersonalization();
      if (this.lmContextService.is3_5Content(personalization.appDisplay)) {
        const comp: LMHtmlUrlDocComponent = this.routeComponent.getHtmlUrlDocComponent();
        comp.runActionFormIn3_5(menuUrl);
      } else {
        this.lmBannerMenuService.requestActionFromPageMenu(menuUrl, resourceId, this.placeholder);
      }
    } else {
      this.lmGlobalUtilService.navigateByUrl(menuUrl);
    }
  }

  private processAccessibility(): void {
    if ([ ...this.webAppSpecsWithSearchResults, ...this.reportSearchResults, ...this.dataSearchResults ].length) {
      this.accessibility.announcement = Soho.Locale.translate('SearchResultsFound', this.model.searchFieldValue);

      if (this.limitSearch) {
        this.accessibility.announcement += `. ${Soho.Locale.translate('SearchResultLimited')}`;
      }
    } else {
      this.accessibility.announcement = Soho.Locale.translate('NoSearchResultsFound');
    }
  }

  private _handleError(error: any): void {
    this.lmErrorUtilService.handleUnexpectedError(error);
  }

  private triggerKeyUpEventOnSearch() {
    const event = new KeyboardEvent('keyup', { bubbles:true });
    setTimeout(() => this.searchField.element.nativeElement.dispatchEvent(event));
  }
}
